import { POPUP_KEY_RESTORE_PRODUCT } from "../constant";
import { PRODUCT_URL, postFetchRequest } from "../store/requests";
import i18n from "../i18nService";
import { productsService } from "./productsService";
import { productsStorage } from "./productsStorage";
import {errorCallback, makeUrl} from "../util";

export const productRestoreService = {
    restoreItem(itemId, notifyItemsList) {
        postFetchRequest(makeUrl([PRODUCT_URL, itemId, '/?restore=true']), null, notifyItemsList, errorCallback, true);
    },
    getItemTitle(itemId, i18nInstance = i18n) {
        return productsService.getLocalization(i18nInstance.resolvedLanguage, productsStorage.getById(itemId), true, i18nInstance);
    },
    getPopupKey() {
        return POPUP_KEY_RESTORE_PRODUCT;
    },
};
